import React from 'react';

const Button = ({ children, variant = 'primary', size = 'md', fullWidth, disabled, icon, onClick, style, className = '' }) => {
  const base = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: 'Inter, sans-serif', fontWeight: 600, letterSpacing: '-0.01em',
    transition: 'all 0.2s ease', opacity: disabled ? 0.5 : 1,
    position: 'relative', overflow: 'hidden',
  };

  const variants = {
    primary: {
      background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
      color: '#FFFFFF', boxShadow: '0 4px 20px rgba(255,61,113,0.3)',
    },
    secondary: {
      background: 'rgba(255,255,255,0.08)', color: '#FFFFFF',
      border: '1px solid rgba(255,255,255,0.10)',
    },
    ghost: {
      background: 'transparent', color: '#A1A1AA',
    },
    danger: {
      background: 'rgba(239,68,68,0.15)', color: '#EF4444',
      border: '1px solid rgba(239,68,68,0.2)',
    },
    outline: {
      background: 'transparent', color: '#FF3D71',
      border: '1.5px solid #FF3D71',
    },
  };

  const sizes = {
    sm: { padding: '8px 16px', fontSize: 13, borderRadius: 10 },
    md: { padding: '14px 24px', fontSize: 15, borderRadius: 14 },
    lg: { padding: '16px 28px', fontSize: 16, borderRadius: 16 },
    xl: { padding: '18px 32px', fontSize: 17, borderRadius: 18 },
    icon: { width: 56, height: 56, borderRadius: 28, padding: 0, fontSize: 20 },
    'icon-sm': { width: 44, height: 44, borderRadius: 22, padding: 0, fontSize: 18 },
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      className={className}
      style={{ ...base, ...variants[variant], ...sizes[size], width: fullWidth ? '100%' : undefined, ...style }}
    >
      {icon && <span style={{ display: 'flex', fontSize: 'inherit' }}>{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
